import { render, staticRenderFns } from "./ContractsCustomer.vue?vue&type=template&id=85051038&scoped=true&"
import script from "./ContractsCustomer.vue?vue&type=script&lang=js&"
export * from "./ContractsCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85051038",
  null
  
)

export default component.exports